// client/src/pages/templates/FieldTemplateList.js
import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SmartDataTable from "../../components/SmartDataTable";
import { useOrg } from "../orgs/org-context"; // <-- adjust path if yours differs

export default function FieldTemplateList() {
  const navigate = useNavigate();
  const { activeOrgId, activeOrg } = useOrg();
  const orgId =
    activeOrgId ||
    activeOrg?._id ||
    (typeof window !== "undefined" && localStorage.getItem("activeOrgId")) ||
    "none";

  const [selectedId, setSelectedId] = useState(null);

  // Clear the current radio selection when org changes
  useEffect(() => {
    setSelectedId(null);
  }, [orgId]);

  // Columns: counter, radio-selectable name, ellipsized description, updated date
  const columns = useMemo(
    () => [
      { label: "#", type: "count", value: "__count", width: "48px", align: "center" },
      {
        label: "Name",
        value: "name",
        align: "left",
        width: "260px",
        type: "render",
        search: "name",
      },
      {
        label: "Description",
        value: "description",
        align: "left",
        width: "320px", // narrower so Actions don't wrap
        type: "render",
        search: "description",
        render: (row) => (
          <div
            style={{
              maxWidth: 320,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={row.description || ""}
          >
            {row.description || ""}
          </div>
        ),
      },
      {
        label: "Updated",
        value: "updatedAt",
        width: "160px",
        align: "left",
        type: "render",
        render: (r) => (r.updatedAt ? new Date(r.updatedAt).toLocaleString() : ""),
      },
    ],
    [selectedId]
  );

  const config = {
    pageTitle: "Field Templates",
    queryName: "/templates/gettemplates",
    pageSize: 20,
    buttons: [
        { label: "View", class: "btn-return", action: "/templates/viewtemplate/{_id}" },
        { label: "Edit", class: "btn-edit", action: "/templates/editfieldtemplate/{_id}" },
    ],
    headerActions: (
      <>

        <button
          className="btn-save add-new-button"
          onClick={() => navigate("/templates/addtemplate")}
        >
          Add New Project Template
        </button>
        <button
          className="btn-save add-new-button"
          onClick={() => navigate("/datasets/add")}
        >
          Add New Project
        </button>
      </>
    ),
  };

  const handleAddDataSet = () => {
    if (!selectedId) {
      toast.info("Select a template first.");
      return;
    }
    navigate(`/datasets/add?templateId=${encodeURIComponent(selectedId)}`);
  };

  const handleAddTemplate = () => navigate("/templates/addtemplate");

  return (
    <div className="datatable-page">
      {/* Title bar -- same pattern as Landing Pages */}
      <div
        className="datatable-header-row"
        style={{ justifyContent: "space-between" }}
      >
        <div style={{ fontSize: 18, fontWeight: 700, paddingLeft: 20}}>
          Project Templates
        </div>
      </div>
      {/* Key by org so the list resets & refetches when header org changes */}
      <SmartDataTable
        key={`templates-${orgId}`}
        config={config}
        columns={columns}
        resetOnMount={true}
      />
    </div>
  );
}
